export const GET_OEM_PARTNER_REQUEST = 'GET_OEM_PARTNER_REQUEST';
export const GET_OEM_PARTNER_SUCCESS = 'GET_OEM_PARTNER_SUCCESS';
export const GET_OEM_PARTNER_FAILURE = 'GET_OEM_PARTNER_FAILURE';

export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAILURE = 'SEND_EMAIL_FAILURE';

export const CLEAR_OEM_DATA = 'CLEAR_OEM_DATA';